module.exports = __webpack_public_path__ + "img/sql-server.04a7ba47.png";